import { RouterManager } from '@aclass/admin/managers';
import { OfflineBookingEmailStory } from '@aclass/admin/storage/actions';
import { IAdminState, IOfflineBookingEmailModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class OfflineBookingEmailSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:offline-booking-email-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IOfflineBookingEmailModuleState['searchPageInitialized']>(['offlineBookingEmailModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(OfflineBookingEmailSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(OfflineBookingEmailStory.dryRunSearchPage());
    }
}
